import { render, staticRenderFns } from "./field-textarea-c.vue?vue&type=template&id=0c213666&scoped=true"
import script from "./field-textarea-c.vue?vue&type=script&lang=js"
export * from "./field-textarea-c.vue?vue&type=script&lang=js"
import style0 from "./field-textarea-c.vue?vue&type=style&index=0&id=0c213666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c213666",
  null
  
)

export default component.exports